import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import splashLogo from 'assets/images/splash-logo.png';
import Styles from 'views/splashScreen/SplashScreen.module.scss';

const SplashScreen = () => {
  const history = useHistory();
  return (
    <section className={Styles.wrapper}>
      <div className={Styles.innerSection}>
        <img src={splashLogo} alt="Moderate Politics" className={Styles.logoMark} />
        <h1 className={Styles.title}>MODERATE POLITICS</h1>
        <div className={Styles.subtitle}>A platform for moderates and independents</div>
        <button type="button" className={Styles.joinButton} onClick={() => history.push('/home')}>
          <span className={Styles.playIcon} />
          Join
        </button>
        <Link to="/home" className={Styles.chevronLink}>
          <span className={Styles.chevronIcon} />
        </Link>
      </div>
    </section>
  );
};

export default SplashScreen;
